import './instrument';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { reactErrorHandler } from '@sentry/react';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/Store';
import Spinner from './views/spinner/Spinner';
import './_mockApis';
import './utils/i18n';
import { AuthProvider } from "src/guards/firebase/FirebaseContext";

const root = ReactDOM.createRoot(document.getElementById('root'), {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
});

root.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Suspense>
  </Provider>
);
